export default __webpack_public_path__ + "static/media/email-blue.790497b5.svg";